import { CacheData } from '@types';
import axios from 'axios';

export const updateCache = async (leadId: number, data: CacheData) => {
    await axios.put('/api/redis-cache/update-cache', { leadId, data });
};
  
export const resetCache = async (leadId: number) => {
    await axios.put('/api/redis-cache/reset-cache', { leadId });
};
